import { PropertyType } from 'esa-ui-library/lib/types';
import { getDashboard } from '../../../api';
import { ActionsType } from '../../../common';
import {
	getFiltersUrl,
	mapBarChartResponse,
	mapChartResponse,
	mapDoughnutChartResponse,
} from '../../../view/pages/Dashboard/Dasboard.helper';

const getDashboardByType = async (data: PropertyType) => {
	const { token, filters } = data;
	const query = getFiltersUrl(filters);
	const response = await getDashboard({
		token,
		query: query,
	});
	return response;
};

const dashboardInit = async (data: PropertyType) => {
	const dasboard = await getDashboardByType(data);

	return {
		summary: {
			bet: mapBarChartResponse(dasboard.games.bet, 'Bet', 1),
			ggr: mapBarChartResponse(dasboard.games.ggr, 'GGR', 1),
		},
		devices: mapDoughnutChartResponse(dasboard.devices, 'Bet'),
		dashboardLoading: false,
		statistics: dasboard.statistics,
		categories: mapDoughnutChartResponse(dasboard.categories, 'Uap'),
		big_wins: dasboard.games.win,
		providers: mapChartResponse(dasboard.operators, 'Bet'),
		filters: data.filters,
	};
};

const filterData = (data: PropertyType) => {
	return dashboardInit(data);
};

const onFilter = async (state: PropertyType, payload: PropertyType) => {
	return filterData(payload);
};

export const actions: ActionsType = {
	LOADING: (state, payload) => ({ dashboardLoading: payload }),
	DASHBOARD_INIT: (state, payload) => dashboardInit(payload),
	FILTER: (state, payload) => onFilter(state, payload),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '' }),
};
